module.exports = __webpack_public_path__ + "img/ANONYMOUS.jpg";